export const Questions = [
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/BIO%20ENG%2010.png?alt=media&token=c12862c5-cb80-4c29-8b05-548ff00ce384",
        optionA: "ANTHRO 184",
        optionB: "COLWRIT R1A",
        optionC: "MATH 1B",
        optionD: "BIO ENG 10",
        answer: "D"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/COLWRIT%20R1A.png?alt=media&token=46c77904-e4c1-4c10-a9b2-c013a02b224d",
        optionA: "COLWRIT R1A",
        optionB: "COMPSCI 70",
        optionC: "EECS 16A",
        optionD: "DATA C8",
        answer: "A"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/COMPSCI%2070.png?alt=media&token=99076b2a-7ebb-444c-b41c-b67438368c13",
        optionA: "MUSIC 158A",
        optionB: "ART W23AC",
        optionC: "COMPSCI 70",
        optionD: "EECS 16A",
        answer: "C"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/COMPSCI%2088.png?alt=media&token=8932351c-92ab-49ec-ac58-6c67bc74100c",
        optionA: "COMPSCI 88",
        optionB: "FILM R1A",
        optionC: "GEOG 10AC",
        optionD: "COMPSCI 10",
        answer: "A"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/UGBA%2010.png?alt=media&token=a30c0c5f-e8c8-4765-abc6-8edd4a1a9aad",
        optionA: "RHETOR R1A",
        optionB: "MATH 1A",
        optionC: "EECS 126",
        optionD: "UGBA 10",
        answer: "D"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/MATH%201A.png?alt=media&token=4fb7eb10-2dc6-4c3f-b2e3-9ab417b3de8d",
        optionA: "DATA C104",
        optionB: "COMPSCI 195",
        optionC: "MATH 1A",
        optionD: "MATH 54",
        answer: "C"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/MATH%201B.png?alt=media&token=490a71e2-cb94-434b-ba17-6ce94998f0f3",
        optionA: "ECON 1",
        optionB: "UGBA 10",
        optionC: "MATH 1B",
        optionD: "RHETOR R1A",
        answer: "C"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/EECS%2016A.png?alt=media&token=8936b270-4514-45da-bae5-7e50b8beb39b",
        optionA: "MATH 1B",
        optionB: "ECON 2",
        optionC: "COMPSCI 70",
        optionD: "EECS 16A",
        answer: "D"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/COMPSCI%20195.png?alt=media&token=1ca8e665-069c-4a7e-b207-0b5a1816a79b",
        optionA: "ESPM 50AC",
        optionB: "COMPSCI 195",
        optionC: "COMPSCI 61C",
        optionD: "EECS 16A",
        answer: "B"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/COMPSCI%2061C.png?alt=media&token=d7509632-4f75-4af6-bf1f-ad408c3c5bf8",
        optionA: "MATH 54",
        optionB: "COMPSCI 61C",
        optionC: "UGBA 10",
        optionD: "DATA C104",
        answer: "B"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/MATH%2053.png?alt=media&token=3455bf1e-7336-45eb-bdc9-d8d58b17bae6",
        optionA: "MATH 53",
        optionB: "COMPSCI 195",
        optionC: "ENGLISH R1A",
        optionD: "COLWRIT R4B",
        answer: "A"
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/cal-grade-distribution-game.appspot.com/o/EECS%2016B.png?alt=media&token=807fbaa6-3651-4402-9803-5b8a88f8876b",
        optionA: "EECS 16B",
        optionB: "COMLIT R1A",
        optionC: "EECS 126",
        optionD: "JAPAN 7A",
        answer: "A"
    },
]